import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FLAGS } from "@/components/LanguageSwitcher";

const TARGETS = {
  book: { NL: "/book", FR: "/fr/book" },
  quote: { NL: "/quote", FR: "/fr/inquiry" },
};

export default function MarketChoiceDialog({ mode, onClose }) {
  const { t } = useTranslation();
  const nav = useNavigate();
  const go = (c) => { onClose(); nav(TARGETS[mode][c]); };
  const opts = [
    { c: "NL", flag: "NL", title: t("country.nl"), sub: t(`market_dialog.nl_${mode}`), hover: "hover:ring-[#5BA83F] hover:bg-[#E8F5E4]/50" },
    { c: "FR", flag: "FR", title: t("country.fr"), sub: t(`market_dialog.fr_${mode}`), hover: "hover:ring-[#0EA5E9] hover:bg-sky-50/60" },
  ];
  return (
    <Dialog open={!!mode} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="tl-public max-w-md rounded-3xl" data-testid="market-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-normal text-[#0F172A]">{mode && t(`market_dialog.${mode}_title`)}</DialogTitle>
          <DialogDescription>{t("market_dialog.sub")}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-3 mt-2">
          {mode && opts.map((o) => (
            <button key={o.c} type="button" onClick={() => go(o.c)} data-testid={`market-dialog-${o.c.toLowerCase()}`}
              className={`group flex items-center gap-4 text-left rounded-2xl ring-1 ring-slate-200 p-4 transition-[background-color,box-shadow] ${o.hover}`}>
              <span className="block w-10 h-10 rounded-full overflow-hidden ring-1 ring-black/10 shrink-0">{FLAGS[o.flag]}</span>
              <span className="flex-1">
                <span className="block font-bold text-[#0F172A]">{o.title}</span>
                <span className="block text-xs text-slate-500 mt-0.5">{o.sub}</span>
              </span>
              <ArrowRight className="w-4 h-4 text-slate-400 transition-transform group-hover:translate-x-1" />
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
